import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HealingPlayer } from './components/HealingPlayer';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HealingPlayer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
